import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@mui/material";
import { OpenLevelNameEnum } from "common/enums/OpenLevelEnum";
import { DialogHeader } from "components/Parts/Atoms/DialogHeader";
import React from "react";
import styles from "./OpenLevelSelectDialog.module.scss";
import { useOpenLevelSelectDialogHooks } from "./hooks";
import { OpenLevelSelectDialogProps } from "./interfaces";

export const OpenLevelSelectDialog = React.memo(
  (props: OpenLevelSelectDialogProps) => {
    const {
      openLevels,
      busy,
      onOpenLevelClick: onModeClick,
      onOkClick
    } = useOpenLevelSelectDialogHooks(props);

    return (
      <>
        <Dialog
          style={props.style}
          className={`${props.className} ${styles.dialog}}`}
          open={props.open}
          onClose={props.onClose}
          aria-labelledby="openLevels-select-title"
          aria-describedby="openLevels-select-description"
          fullWidth
          slotProps={{
            paper: { className: styles.dialogPaper },
            backdrop: { className: styles.backdrop }
          }}
        >
          <DialogHeader
            id="openLevels-select-title"
            icon={<PanToolAltIcon />}
          />
          <DialogContent id="openLevels-select-description">
            <Box className={styles.paragraph}>
              <Box
                className={`${styles.button} ${
                  openLevels.includes(OpenLevelNameEnum.社内)
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onModeClick(OpenLevelNameEnum.社内)}
              >
                {OpenLevelNameEnum.社内}
              </Box>
              <Box
                className={`${styles.button} ${
                  openLevels.includes(OpenLevelNameEnum.支店内)
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onModeClick(OpenLevelNameEnum.支店内)}
              >
                {OpenLevelNameEnum.支店内}
              </Box>
            </Box>
          </DialogContent>
          <DialogActions className={styles.actions}>
            <Button
              variant="contained"
              className={styles.cancelButton}
              disabled={busy}
              onClick={props.onCloseClick}
            >
              キャンセル
            </Button>
            <Button
              variant="contained"
              className={styles.okButton}
              disabled={busy || openLevels.length === 0}
              onClick={onOkClick}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
);
